import { Select } from 'common/form-controls';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import styled from 'styled-components';
import { Flex, RadioButtons } from 'ui';

const StyledInputDiv = styled.div`
  margin-top: 13px;
  width: 40%;
`;

const StyledFlex = styled(Flex)`
  width: 100%;
`;

// eslint-disable-next-line no-undefined
const fieldRequired = value => value ? undefined : 'Required';
// eslint-disable-next-line
const maxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined;
const maxLength40 = maxLength(40);
const BusinessIndicatorWizard = ({
  data,
  intl,
  onSelectionChange,
  renderInputMaxLen,
  renderInput,
  handleRadioChange,
}) =>
  <>
    {data.indicatorTypes && data.indicatorTypes.length > 0 &&
      <StyledFlex ffrn jcfs aic>
        <Select
          name='indicatorType'
          label={intl.formatMessage({ id: 'typesForm.labels.INDICATOR' })}
          placeholder={intl.formatMessage({
            id: 'typesForm.placeholders.ORDER_TYPE',
          })}
          onSelectionChange={onSelectionChange}
          searchable={true}
          items={data.indicatorTypes}
        />
        {data.splitInvoiceIndicator ?
          <RadioButtons
            title={intl.formatMessage({ id: 'typesForm.labels.SPLIT_INVOICE' })}
            name='splitInvoice'
            onChange={handleRadioChange}
            values={[
              {
                key: 0,
                description: intl.formatMessage({ id: 'common.NO' }),
              },
              {
                key: 1,
                description: intl.formatMessage({ id: 'common.YES' }),
              },
            ]}
          /> :
          null
        }
      </StyledFlex>
    }
    {(data?.indicatorBusinessSubTypes?.length > 1 ||
      (
        data?.indicatorBusinessSubTypes?.length === 1 &&
        !data?.indicatorBusinessSubTypes.find(v => v.isDefault)
      )
    ) &&
      <Select
        name='businessSubType'
        label={intl.formatMessage({ id: 'typesForm.labels.BUSINESS_SUB_TYPE' })}
        placeholder={intl.formatMessage({
          id: 'typesForm.placeholders.BUSINESS_SUB_TYPE',
        })}
        onSelectionChange={onSelectionChange}
        searchable={true}
        required={false}
        disabled={!data?.isFiscalCodeServiceCenter}
        items={data?.indicatorBusinessSubTypes.map(v => ({
          id: v.additionalParameter,
          text: v.description,
        }))}
      />
    }
    {data.indicatorInputs &&
      data.indicatorInputs.length > 0 &&
      data.indicatorInputs?.map((input) => {
        if (input.type === 'dropdown') {
          return (
            <Select
              key={input.name}
              name={input.name}
              label={input.description}
              onSelectionChange={onSelectionChange}
              searchable={true}
              items={input.values && input.values?.map(v => ({
                ...v,
                text: v.description,
              }))}
            />
          );
        } else if (input.type === 'text') {
          return (
            <StyledInputDiv key={input?.name}>
              <Field
                key={input.name}
                name={input.name}
                description={input.description}
                component={renderInput}
                validate={[fieldRequired]}
                disabled={input.readonly}
              />
            </StyledInputDiv>
          );
        }
        return (
          <Select
            key={input.name}
            name={input.name}
            label={input.description}
            onSelectionChange={onSelectionChange}
            searchable={true}
            items={input.values && input.values?.map(v => ({
              ...v,
              text: v.description,
            }))}
          />
        );
      })}
    {data.shouldRenderIndicatorDescription &&
      <StyledInputDiv>
        <Field
          name='description_custom'
          description={intl.formatMessage({ id: 'typesForm.labels.ORDER_DESCRIPTION' })}
          max={40}
          component={renderInputMaxLen}
          validate={[
            fieldRequired,
            maxLength40,
          ]}
        />
      </StyledInputDiv>
    }
  </>;
BusinessIndicatorWizard.propTypes = {
  onSelectionChange: PropTypes.func,
  renderInputMaxLen: PropTypes.func,
  renderInput: PropTypes.func,
  handleRadioChange: PropTypes.func,
  data: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(BusinessIndicatorWizard);
